var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('Chart',{attrs:{"path":`${_vm.path}.cols[0]`,"type":"row"}}),_vm._v(" "),_vm._l((_vm.nbCols - 1),function(i){return _c('b-col',{key:i,staticClass:"align-content-stretch"},[_c('Chart',{attrs:{"path":`${_vm.path}.cols[${i}]`}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }